// This module was originally created so that Recast could add its own
// custom types to the AST type system (in particular, the File type), but
// those types are now incorporated into ast-types, so this module doesn't
// have much to do anymore. Still, it might prove useful in the future.
module.exports = require("ast-types");



//////////////////
// WEBPACK FOOTER
// ./~/recast/lib/types.js
// module id = 2
// module chunks = 0